//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
  name: 'myProduct',
  components: {
      cmBlank,cmLoadmore,wx
  },
  data () {
    return {
        title:'产品管理',
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      title:'',
      pageFlag:2,
      hasNext:0,
      lastId:0,
      list:[],
    }
  },
  created(){
   
  },
  amount(){
  },
  methods:{
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    getList(){
        this.$api.getCurtainGoods({last_id:this.lastId,page_flag:this.pageFlag,title:this.title}).then((res)=>{
          if(res){
            // console.log(res);
            if(!this.lastId){
                this.blankShow = res.data.length > 0 ? false : true;
            }
            this.hasNext = res.hasNext;
            this.lastId = res.lastId;
            res.data.forEach((item)=>{
                this.list.push(item);
            });
          }
        })  
    },
    showPic(item,index) {
        wx.previewImage({
            current: item[index], // 当前显示图片的http链接
            urls: item // 需要预览的图片http链接列表
        });
    },
    edit(id){
        this.$router.push({name:'curtainAddGoods',params:{id:id}})
    },
    del(id){
         this.$func.confirm('确认删除？','提示',()=>{
            this.$api.changeCurtainGoodsStatus({id:id,status:'-1'}).then((res)=>{
                if(res){
                    setTimeout(()=>{
                        this.list = [];
                        this.lastId = 0;
                        this.hasNext = 0;
                        this.loadmore();
                    }, 300);
                }
            });
        })
    },
    loadmore(){
        if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        // console.log(1111);
        this.getList();
        setTimeout(()=>{
           if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/curtainGoods.vue